import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, ShieldCheck, FileStack, Clock, AlertTriangle, UserX, MessageSquareWarning, TimerOff, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const CARDS = [
  { key: "total_members", label: "JUMLAH AHLI", icon: Users, color: "text-piks-black", to: "/admin/ahli" },
  { key: "active_members", label: "AHLI AKTIF", icon: ShieldCheck, color: "text-emerald-600", to: "/admin/ahli?status=ACTIVE" },
  { key: "expiring_soon", label: "AKAN TAMAT TEMPOH", icon: AlertTriangle, color: "text-amber-600", to: "/admin/ahli?status=EXPIRING_SOON" },
  { key: "expired_members", label: "AHLI TAMAT TEMPOH", icon: TimerOff, color: "text-piks-red", to: "/admin/ahli?status=EXPIRED" },
  { key: "inactive_members", label: "AHLI TIDAK AKTIF", icon: UserX, color: "text-piks-muted", to: "/admin/ahli?status=SUSPENDED" },
  { key: "pending_applications", label: "PERMOHONAN BAHARU", icon: FileStack, color: "text-blue-600", to: "/admin/permohonan?status=DIHANTAR" },
  { key: "in_review", label: "DALAM SEMAKAN", icon: Clock, color: "text-amber-600", to: "/admin/permohonan?status=DALAM_SEMAKAN" },
  { key: "requires_changes", label: "PERLU PEMBETULAN", icon: MessageSquareWarning, color: "text-piks-red", to: "/admin/permohonan?status=PERLU_MAKLUMAT_TAMBAHAN" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard-page">
      <h1 className="font-display text-2xl font-bold text-piks-black mb-1">Dashboard</h1>
      <p className="text-sm text-piks-muted mb-8">Ringkasan statistik keahlian Bodyguard Sarawak.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <button
            key={c.key}
            onClick={() => navigate(c.to)}
            data-testid={`admin-stat-${c.key}`}
            className="group p-6 rounded-xl bg-white border border-piks-border text-left cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:border-piks-gold hover:shadow-md"
          >
            <div className="flex items-center justify-between mb-4">
              <c.icon className={`w-5 h-5 ${c.color}`} />
              <ArrowRight className="w-3.5 h-3.5 text-piks-muted opacity-0 group-hover:opacity-100 group-hover:translate-x-0.5 transition-all duration-200" />
            </div>
            <p className="font-display text-3xl font-bold text-piks-black">{stats ? stats[c.key] : "-"}</p>
            <p className="text-[11px] text-piks-muted uppercase tracking-wide mt-1">{c.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
